/**
 * AuthGuard · protège les routes privées.
 * - Pendant le boot (refresh silencieux) : affiche un splash.
 * - Si anonyme : redirige sur /login en gardant l'URL d'origine.
 * - Si authentifié : rend les enfants.
 */
import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router";
import { useAuth } from "./AuthContext";
import { Logo } from "../ui/Logo";

export function AuthGuard({ children }: { children: ReactNode }) {
  const { status } = useAuth();
  const location = useLocation();

  if (status === "loading") {
    return <SplashLoading />;
  }
  if (status === "anonymous") {
    return (
      <Navigate
        to="/login"
        state={{ from: location.pathname + location.search }}
        replace
      />
    );
  }
  return <>{children}</>;
}

export function GuestGuard({ children }: { children: ReactNode }) {
  const { status } = useAuth();
  if (status === "loading") return <SplashLoading />;
  if (status === "authenticated") return <Navigate to="/" replace />;
  return <>{children}</>;
}

function SplashLoading() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-white">
      <div className="flex flex-col items-center gap-4">
        <Logo size={48} />
        <div className="h-1 w-32 overflow-hidden rounded-full bg-navy-100">
          <div className="h-full w-1/2 animate-pulse rounded-full bg-accent-500" />
        </div>
      </div>
    </div>
  );
}
